module.exports = __webpack_public_path__ + "img/PVO.71f694fa.png";